import { render, staticRenderFns } from "./Aoda.vue?vue&type=template&id=37bacce8&scoped=true&"
import script from "./Aoda.vue?vue&type=script&lang=js&"
export * from "./Aoda.vue?vue&type=script&lang=js&"
import style0 from "./Aoda.vue?vue&type=style&index=0&id=37bacce8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bacce8",
  null
  
)

export default component.exports